import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';
import { Layout } from 'ui';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <Layout
      pageTitle="File transfer"
      userName={currentUser?.name}
      userLogout={currentUser?.actions?.logout}
      noPageTitleHeader={true}
      customMainStyle={{
        minHeight: `calc(100vh - ${60}px - ${60}px)`,
        minWidth: '460px',
        backgroundColor: '#fff',
      }}
      customHeaderStyle={{
        background: 'linear-gradient(to right, #115ab7, #16a5d1)',
      }}
    >
      <CompanySelector
        user={currentUser}
        options={{
          gascaribe: {
            path: '/gascaribe/transactions',
            role: 'file_transfer_gascaribe',
          },
          gasguajira: {
            path: '/gasguajira/transactions',
            role: 'file_transfer_gasguajira',
          },
          efigas: {
            path: '/efigas/transactions',
            role: 'file_transfer_efigas',
          },
        }}
      />
    </Layout>
  );
};

export default Home;
